import React from "react";
import styles from "./PageLoader.module.css";

export default function PageLoader({ label = "Loading dashboard..." }) {
  return (
    <div className={styles.wrap} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.spinner} />
      <p>{label}</p>
    </div>
  );
}
